// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Iuaq","vLegacy":"SelectSecondary_vLegacy__2t1TE","error":"SelectSecondary_error__22RWl","disabled":"SelectSecondary_disabled__2THMJ"};